<template>
  <div id="engineerStockQuery">
    <el-form ref="searchForm" :inline="true" :model="searchForm" :label-position="labelPosition">
      <el-form-item style=" margin-bottom:5px" class="hewidth">
        <el-select v-model="searchForm.type" @change="pickingType" placeholder="请选择是否包含特配" clearable>
          <el-option v-for="(item,index) in pickingList"
                     :label="item.paraName"
                     :value="item.paraCode"
                     :key="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-bottom:15px" class="hewidth">
        <el-select v-model="searchForm.warehouseType" placeholder="仓库类型" clearable>
          <el-option v-for="(item,index) in stockTypeList"
                     :label="item.paraName"
                     :value="item.paraCode"
                     :key="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-bottom:15px" class="hewidth">
        <el-select clearable filterable v-model="searchForm.belonger" @change="changeBelonger"
                   :filter-method="PinyinMatch" placeholder="工程师">
          <el-option v-for="item,index in engineersList"
                     :key="index"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-bottom:15px"class="hewidth">
        <el-input clearable v-model.trim="searchForm.materialCode" placeholder="物料编码"></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom:15px"class="hewidth">
        <el-input clearable v-model.trim="searchForm.materialName" placeholder="物料名称"></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom:15px" class="hewidth">
        <el-input clearable v-model.trim="searchForm.code" placeholder="序列号"></el-input>
      </el-form-item>
      
      <el-row>
        <el-form-item style="margin-bottom: 15px;" class="hewidth">
          <el-select clearable v-model="searchForm.brandId" placeholder="品牌" @change="selectFormBrand">
            <el-option v-for="(item,index) in brandFormList" :key="index" :label="item.brandName" :value="item.brandId">
              {{item.brandName}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;" class="hewidth">
          <el-select clearable v-model="searchForm.categoryId" @change="selectFormCategory" placeholder="品类">
            <el-option v-for="(item,index) in categoryFormList" :selected="{'selected':index==0}" :key="index"
                       :label="item.categoryName" :value="item.categoryId">{{item.categoryName}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px;" class="hewidth">
          <el-select clearable filterable v-model="searchForm.modelId" @change="selectFormModel" placeholder="型号">
            <el-option v-for="(item,index) in modelFormList" :key="index" :label="item.modelName" :value="item.modelId">
              {{item.modelName}}
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item style="margin-bottom: 15px;">
            <el-select clearable filterable v-model="searchForm.colorId" @change="getMateriaList" placeholder="颜色">
                <el-option v-for="(item,index) in colorFormList" :key="index"  :label="item.colorName" :value="item.colorId">{{item.colorName}}</el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 15px;" class="hewidth">
          <el-select clearable filterable v-model="searchForm.materialCoding" placeholder="物料"
                     @change="getEngineerStockList">
            <el-option v-for="(item,index) in materialFormList" :key="index" :label="item.materialName"
                       :value="item.materialCoding">{{item.materialName}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width: 14%； margin-bottom: 15px;">
        <el-button type="primary" size="medium" @click="SubmitSearch('searchForm')">查询</el-button>
        <!-- <el-button type="text" @click="clearFrom()" style="color: #169BD5;">重置</el-button> -->
        <el-button type="success" size="medium" @click="exportWarehouseList()">导出</el-button>
          <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 8px;" @click="refresh()"></i>
      </el-form-item>
      <!-- <el-form-item class="fr">
        <el-col style="width: 16%； text-align:right" >
          
        </el-col>
      </el-form-item> -->
      </el-row>
    </el-form>
    <el-card class="box-card" style="width: 100%">
      <el-table
        :data="tableData"
        border
        v-loading="loading1"
        :header-cell-style="{'text-align':'center'}"
        :summary-method="getSummaries"
        show-summary
        id="tableId"
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          width="105"
          prop="materialCode"
          label="物料编号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="modelName"
          width="110"
          label="型号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="materialName"
          width="230"
          label="物料名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="warehouseType"
          
          label="仓库类型">
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          
          label="工程师">
        </el-table-column>
        <el-table-column
          align="center"
          prop="sum1"
          label="库存总数">
        </el-table-column>
        <el-table-column
          align="center"
          prop="sumPrice"
          label="库存价值">
        </el-table-column>
        <el-table-column
          align="center"
          prop="specialNumber"
         
          label="特配数">
          <template slot-scope="scope">
		              	<span v-if="(scope.row.sum2 - scope.row.sum) > 0">
			                {{ scope.row.sum1 - scope.row.sum}}
			            </span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="sum2"
          
          label="未使用">
        </el-table-column>
        <el-table-column
          align="center"
          prop="sum3"
         
          label="已使用">
        </el-table-column>
        <el-table-column
          align="center"
          prop="waringCount"
         
          label="售前数">
        </el-table-column>
        <el-table-column
          align="center"
          prop="sum4"
          
          label="售后数">
        </el-table-column>
        <el-table-column
          align="center"
          
          label="操作" v-if="basicsAuth.all_serial_number">
          <template slot-scope="scope">
            <el-button @click.stop="showSerialNumber(scope.row.materialCoding,null, scope.row.engineerId,0)" type="text"
                       size="small">查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100,1000]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next,jumper"
            :total="pages.total">
          </el-pagination>
        </div>
      </el-col>
    </el-card>
    <!-- 查看序列号弹出框 -->
    <el-dialog class="dialog-content-self" title="序列号类型" :visible.sync="dialogTableVisible">
      <el-row class="table-filter-content">
        <el-button :class="{active:shift==0}" @click="handleShift(0)">全部序列号</el-button>
        <el-button :class="{active:shift==1}" @click="handleShift(1)">未使用序列号</el-button>
        <el-button :class="{active:shift==2}" @click="handleShift(2)">已使用序列号</el-button>
        <el-button :class="{active:shift==3}" @click="handleShift(3)">售前序列号</el-button>
        <el-button :class="{active:shift==4}" @click="handleShift(4)">售后序列号</el-button>
      </el-row>
      <el-row
        class="dialog-code-content"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <el-col v-for="(item,index) in codeList" :key="index" :span="6">
          <p>{{item.code}}</p>
        </el-col>
      </el-row>
      <!--分页-->
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleNumberSizeChange"
            @current-change="handleNumberCurrentChange"
            :current-page="numberPages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="numberPages.pageSize"
            layout="total, sizes, prev, pager, next,jumper"
            :total="numberPages.total">
          </el-pagination>
        </div>
      </el-col>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import axios from 'axios';
  import store from '@/store/store';
  import ip from '@/config/ip.js';
  import PinyinMatch from 'pinyin-match';
  import {
    engineerInventoryList,
    engineerList,
    engineerSerialList,
    queryColor,
    selectAllBrand,
    selectCategory,
    selectMaterialManagements,
    selectModel,
    selectParameterInfoBusiness
  } from "../../api/api";
  import {getPermission} from '../../api/authRequest'

  export default {
    name: 'engineerStockQuery',
    data() {
      const validateNumber = (rule, value, callback) => {
        if (/^[1-9]\d*|0$/.test(value) == false) {
          callback(new Error("请输入一个大于0的整数"));
        } else {
          callback();
        }
      }
      return {
        activeIndex: '',
        labelPosition: 'left',
        pickingList: [
          {
            paraName: '全部',
            paraCode: '0'
          },
          {
            paraName: '特配',
            paraCode: '1'
          },
          {
            paraName: '非特配',
            paraCode: '2'
          },
        ],
        brandFormList: [],
        categoryFormList: [],
        modelFormList: [],
        colorFormList: [],
        materialFormList: [],
        stockTypeList: [],
        engineersList: [],
        copy: [],
        searchForm: {
          warehouseType: '',
          materialCode: '',
          code: '',
          belonger: '',
          type: '0'
        },
        dialogTableVisible: false, //弹出框
        shift: 0,
        engineerId: '',
        codeList: [], //序列号数组
        loading: false, //加载状态
        loading1: false,//加载状态
        tableData: [],
        //分页变量
        pages: {
          total: 0,
          page: 1,
          pageSize: 10,
        },
        //分页变量
        numberPages: {
          total: 0,
          page: 1,
          pageSize: 10,
        },
        basicsAuth: {
          all_serial_number: false
        }
      }
    },
    components: {},
    created() {
      this.getStockType();
      this.getEngineerList();
      this.getEngineerStockList();
      this.getBrandList();
    },
    mounted() {
      this.basicsAuth.all_serial_number = getPermission('/api/inventory/all_serial_number');
    },
    methods: {
      //modelForm选择品牌
      selectFormBrand() {
        this.getCategoryList();
      },
      //modelForm选择品类
      selectFormCategory() {
        this.getModelList();
      },
      //modelForm选择型号
      selectFormModel() {
        this.getColorList();
        this.getMateriaList();
      },
      //机型品牌
      getBrandList() {
        selectAllBrand({}).then(res => {
          if (res.data.status == 100) {
            this.brandFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //机型品类
      getCategoryList() {
        this.searchForm.categoryId = "";
        this.searchForm.modelId = "";
        this.modelFormList = [];
        this.searchForm.colorId = "";
        this.colorFormList = [];
        this.searchForm.materialCoding = "";
        this.materialFormList = [];
        this.searchForm.materialCode = "";
        let para = {
          brandId: this.searchForm.brandId
        };
        selectCategory(para).then(res => {
          if (res.data.status == 100) {
            this.categoryFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //机型型号
      getModelList() {
        this.searchForm.modelId = "";
        this.searchForm.colorId = "";
        this.colorFormList = [];
        this.searchForm.materialCoding = "";
        this.materialFormList = [];
        this.searchForm.materialCode = "";
        let para = {
          brandId: this.searchForm.brandId,
          categoryId: this.searchForm.categoryId
        };
        selectModel(para).then(res => {
          if (res.data.status == 100) {
            this.modelFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //机型颜色
      getColorList() {
        this.searchForm.colorId = "";
        this.searchForm.materialCoding = "";
        this.materialFormList = [];
        this.searchForm.materialCode = "";
        let para = {
          modelId: this.searchForm.modelId
        };
        queryColor(para).then(res => {
          if (res.data.status == 100) {
            this.colorFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //机型物料
      getMateriaList() {
        this.searchForm.materialCoding = "";
        this.searchForm.materialCode = "";
        let para = {
          brandId: this.searchForm.brandId,
          categoryId: this.searchForm.categoryId,
          modelId: this.searchForm.modelId,
          colorId: this.searchForm.colorId,
          startRow: 1,
          pageSize: 1000
        };
        selectMaterialManagements(para).then(res => {
          if (res.data.status == 100) {
            this.materialFormList = res.data.results;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //导出
      exportWarehouseList() {
        let para = {
          warehouseType: this.searchForm.warehouseType,
          materialCode: this.searchForm.materialCode,
          materialName: this.searchForm.materialName,
          code: this.searchForm.code,
          belonger: this.searchForm.belonger,
          type: this.searchForm.type,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize,
        };
        const loading = this.$loading({
          lock: true,
          text: "正在生成文件，请稍等...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        axios({
          url: `${ip.Ips.ip1}/api/export/export_engineer`,
          method: "post",
          headers: {
            "token": `${store.state.token}`
          },
          data: para,
          responseType: 'blob'
        }).then(res => {
          loading.close();
          let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute(
              "download",
              fileName
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //强制刷新
      changeBelonger(e) {
        console.log(e);
        this.searchForm.belonger = e;
        this.$forceUpdate();
      },
      PinyinMatch(val) {
        if (val && val.length > 0) {
          let result = [];
          this.copy.forEach(i => {
            let m = PinyinMatch.match(i.name, val);
            if (m) {
              result.push(i);
            }
          })
          this.searchForm.belonger = val;
          this.engineersList = result;
        } else {
          this.engineersList = this.copy;
          this.searchForm.belonger = "";
        }
      },
      clearFrom() {
        this.searchForm.brandId = "";
        this.searchForm.categoryId = "";
        this.searchForm.modelId = "";
        this.searchForm.colorId = "";
        this.searchForm.materialCoding = "";
        this.searchForm.warehouseType = "";
        this.searchForm.materialCode = "";
        this.searchForm.materialName = "";
        this.searchForm.code = "";
        this.searchForm.belonger = "";
        this.searchForm.type = "0";
        this.getEngineerStockList();
      },
      //获取工程师
      getEngineerList() {
        let params = {
          startRow: 1,
          pageSize: 10000,
        }
        engineerList(params).then(res => {
          if (res.data.status == 100) {
            this.engineersList = res.data.results.list;
            this.copy = Object.assign(this.engineersList); //保留数据源
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //仓库
      getStockType() {
        let para = {
          paraType: "warehouse_type"
        };
        selectParameterInfoBusiness(para).then(res => {
          if (res.data.status == 100) {
            this.stockTypeList = res.data.results.list;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      pickingType() {
        this.getEngineerStockList()
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getEngineerStockList()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getEngineerStockList()
      },
      handleNumberSizeChange(val) {
        this.numberPages.pageSize = val;
        this.handleShift(this.shift);
      },
      handleNumberCurrentChange(Page) {
        this.numberPages.page = Page;
        this.handleShift(this.shift);
      },
      handleShift(num) {
        this.numberPages.page = 1;
        if (num == 0) {
          this.showSerialNumber(this.materialCoding, null, this.engineerId, num);
        } else if (num == 1) {
          this.showSerialNumber(this.materialCoding, 'LPC', this.engineerId, num);
        } else if (num == 2) {
          this.showSerialNumber(this.materialCoding, 'FPC', this.engineerId, num);
        } else if (num == 3) {
          this.showSerialNumber(this.materialCoding, 'SQC', this.engineerId, num);
        } else {
          this.showSerialNumber(this.materialCoding, 'SHC', this.engineerId, num);
        }
      },
      //查询工程师库存
      getEngineerStockList() {
        this.loading1 = true
        let para = {
          brandId: this.searchForm.brandId,
          categoryId: this.searchForm.categoryId,
          modelId: this.searchForm.modelId,
          colorId: this.searchForm.colorId,
          materialCoding: this.searchForm.materialCoding,
          warehouseType: this.searchForm.warehouseType,
          materialCode: this.searchForm.materialCode,
          materialName: this.searchForm.materialName,
          code: this.searchForm.code,
          belonger: this.searchForm.belonger,
          type: this.searchForm.type,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize,
          materialCoding: this.searchForm.materialCoding
        }
        engineerInventoryList(para).then(res => {
          if (res.data.status == 100) {
            this.tableData = res.data.results.list
            this.pages.total = res.data.results.total
            this.loading1 = false
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
            this.loading1 = false
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //清空刷新
      refresh() {
        this.tableData = []
        this.getEngineerStockList()
      },
      //确认检索
      SubmitSearch() {
        this.getEngineerStockList()
      },
       //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }
        if (index < 5) {
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
      //查看序列号
      showSerialNumber(materialCoding, warehouseType, id, num) {
        this.codeList = []; //清空数据
        this.dialogTableVisible = true;
        this.shift = num;
        this.loading = true;
        this.materialCoding = materialCoding;
        this.engineerId = id;
        let para = {
          warehouseType: warehouseType,
          materialCoding: this.materialCoding,
          state: null,
          affiliationType: 1,
          engineerId: this.engineerId,
          code: this.searchForm.code,
          startRow: this.numberPages.page,
          pageSize: this.numberPages.pageSize
        }
        engineerSerialList(para).then(res => {
          if (res.data.status == 100) {
            this.numberPages.total = res.data.results.total;
            this.codeList = res.data.results.list;
            this.loading = false
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
    },
    computed: {},
    watch: {}
  }
</script>

<style lang="scss" scoped>
  #engineerStockQuery {
    padding-top: 10px;
    overflow: hidden;
    *zoom: 1;

    p.headerT {
      margin: 0 0 15px 0;
    }

    .dialog-content-self {
      el-table {
        el-table-column {
          th, tr {
            text-align: center !important;
          }

        }
      }

      .table-filter-content {
        margin-bottom: 20px;
        margin-top: -20px;
      }
    }

    .el-table td, .el-table th {
      text-align: center !important;
    }

    .active {
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }

    .dialog-code-content {
      text-align: center;
      border: 1px solid #e3e3e3;
      min-height: 500px;

      .el-col {
        border: 1px solid #f4f4f4;
        line-height: 40px
      }
    }
  }
  .hewidth {
        width: 15% !important;
      }
</style>



// WEBPACK FOOTER //
// engineerStockQuery.vue?2f0ee2d2